import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataService } from '../../../../../services/data.service';

@Component({
	selector: 'emailtpls-detail-basic-information',
	templateUrl: './basic.html'
})
export class EmailTplsDetailBasicInformation {
	@Input() form: FormGroup;
	@Input() action: string;
	//@Input() message: string;

	public constructor(
		private dataService: DataService
	) {

	}
}


// WEBPACK FOOTER //
// ./src/pages/configs/email-tpls/detail/basic/basic.ts